import { Users, Plus, Hash } from 'lucide-react';
import { useApp } from '../components/AppContext';
import { MainLayout } from '../components/MainLayout';
import { useTranslation } from '../i18n/TranslationContext';

export function GroupSelection() {
  const { navigateDirectly } = useApp();
  const { t } = useTranslation();
  // GroupRouter now handles the check for existing group
  // This component only renders when user doesn't have a group

  const handleCreateGroup = () => {
    navigateDirectly('app-group-create');
  };

  const handleJoinGroup = () => {
    navigateDirectly('app-group-join');
  };

  return (
    <MainLayout showBack={true} onBack={() => navigateDirectly('dashboard')}>
      <div className="space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="w-20 h-20 bg-[var(--ucm-light-blue)] rounded-full flex items-center justify-center mx-auto mb-6">
            <Users size={40} className="text-[var(--ucm-dark-blue)]" />
          </div>
          <h1 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-3">{t('groupSelection.title')}</h1>
          <p className="text-[var(--ucm-text-medium)] px-4">
            {t('groupSelection.subtitle')}
          </p>
        </div>

        {/* Group Options */}
        <div className="space-y-4">
          {/* Create Group Option */}
          <button
            onClick={handleCreateGroup}
            className="w-full bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.12)] transition-all duration-200 text-left"
          >
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-[var(--ucm-primary-teal)] rounded-full flex items-center justify-center flex-shrink-0">
                <Plus size={28} className="text-white" />
              </div>
              <div className="flex-1 pt-1">
                <h3 className="font-semibold text-[var(--ucm-text-dark)] mb-2">{t('groupSelection.createGroup')}</h3>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed">
                  {t('groupSelection.createGroupDescription')}
                </p>
              </div>
              <div className="flex-shrink-0 pt-3">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-[var(--ucm-text-light)]">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </button>

          {/* Join Group Option */}
          <button
            onClick={handleJoinGroup}
            className="w-full bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.12)] transition-all duration-200 text-left"
          >
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-[var(--ucm-success-green)] rounded-full flex items-center justify-center flex-shrink-0">
                <Hash size={28} className="text-white" />
              </div>
              <div className="flex-1 pt-1">
                <h3 className="font-semibold text-[var(--ucm-text-dark)] mb-2">{t('groupSelection.joinGroup')}</h3>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed">
                  {t('groupSelection.joinGroupDescription')}
                </p>
              </div>
              <div className="flex-shrink-0 pt-3">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-[var(--ucm-text-light)]">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </button>


        </div>

        {/* Information Note */}
        <div className="bg-[var(--ucm-light-blue)] border border-[var(--ucm-info-blue)] rounded-2xl p-4">
          <div className="flex items-start space-x-3">
            <span className="text-xl flex-shrink-0">💡</span>
            <div>
              <h4 className="font-semibold text-[var(--ucm-dark-blue)] mb-1">{t('groupSelection.aboutGroups')}</h4>
              <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed">
                {t('groupSelection.aboutGroupsDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}